import { createRoutine } from 'redux-saga-routines';

const SEND_CONTACT_MESSAGE = 'SEND_CONTACT_MESSAGE';
export const sendContactMessageAction = createRoutine(SEND_CONTACT_MESSAGE);
